module.exports = __webpack_public_path__ + "img/train2-inside.5e3e8e44.png";